import { render, staticRenderFns } from "./KeluhanExternal.vue?vue&type=template&id=386b4ed5&scoped=true&"
import script from "./KeluhanExternal.vue?vue&type=script&lang=js&"
export * from "./KeluhanExternal.vue?vue&type=script&lang=js&"
import style0 from "./KeluhanExternal.vue?vue&type=style&index=0&id=386b4ed5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386b4ed5",
  null
  
)

export default component.exports